import React from 'react';
import Header from '../hoc/header/index';
// import Sidebar from '../hoc/sidebar/index';
import DashboardPage from '../pages/dashboard/DashboardPage';
import { useLocation } from 'react-router-dom';

import './style.scss'
import Homepage from '../pages/home/Homepage';
import SidebarComponents from '../hoc/sidebar/sidebarComponents/SidebarComponents';

const LayoutComponent = () => {

    const loc = useLocation();

    return (
        <div className='layout-wrap'>
            <div className='layout-wrap__side-bar'>
                <SidebarComponents />
            </div>
            <div className='layout-wrap__main'>
                <div className='layout-wrap__main__header'>
                    <Header />
                </div>
                <div className='layout-wrap__main__home'>
                    {loc?.pathname === '/' ? (
                        <Homepage />
                    ) : <DashboardPage />}

                </div>
            </div>
        </div>
    )
}

export default LayoutComponent;
